import url from './urls'

const state = {
  isLoading: false,
  programs: null,
  talkSymposiums: null,
  talkSymposiumDetail: null,
  schoolCreatives: null,
  schoolCreativeTime: null,
  schoolCreativeDetail: null
}

const mutations = {
  GETPROGRAM (state, pageName) {
    state.isLoading = true

    fetch(url.creativity.program)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.programs = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETTALKSYMPOSIUM (state) {
    state.isLoading = true

    fetch(url.creativity.talkSymposium)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.talkSymposiums = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETTALKSYMPOSIUMDETAIL (state, id) {
    state.isLoading = true

    fetch(url.creativity.talkSymposiumDetail + id)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.talkSymposiumDetail = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETTSCHOOLCREATIVITY (state) {
    state.isLoading = true

    fetch(url.creativity.schoolCreativity)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.schoolCreatives = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETTSCHOOLCREATIVITYTIME (state, id) {
    state.isLoading = true
    state.schoolCreativeTime = []

    fetch(url.creativity.schoolCreativityTime + id)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.schoolCreativeTime = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETTSCHOOLCREATIVITYDETAIL (state, id) {
    state.isLoading = true
    state.schoolCreativeDetail = []

    fetch(url.creativity.schoolCreativityDetail + id)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.schoolCreativeDetail = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  }
}

const actions = {
  getProgram ({ commit }) {
    commit('GETPROGRAM')
  },

  getTalkSymposium ({ commit }) {
    commit('GETTALKSYMPOSIUM')
  },

  getTalkSymposiumDetail ({ commit }, id) {
    commit('GETTALKSYMPOSIUMDETAIL', id)
  },

  getSchoolCreativity ({ commit }) {
    commit('GETTSCHOOLCREATIVITY')
  },

  getSchoolCreativityTime ({ commit }, id) {
    commit('GETTSCHOOLCREATIVITYTIME', id)
  },

  getSchoolCreativityDetail ({ commit }, id) {
    commit('GETTSCHOOLCREATIVITYDETAIL', id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
